/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/core/RemoveInvalidCharactersFromFileName.ts
 * @create:      2025-07-01 18:01:48.545
 * @modify:      2025-07-11 21:19:12.947
 * @version:     6.0.0
 * @times:       7
 * @lines:       52
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { GetInvalidFileNameChars } from "../data/GetInvalidFileNameChars";
import { RemoveAllSubStrings } from "../string/RemoveAllSubStrings";

/**
 * Removes all invalid characters from a given file name.
 * 
 * This function takes a file name string and an array of invalid characters
 * specific to file names, then removes all occurrences of these invalid characters
 * from the file name string.
 * 
 * @param filename - The file name string from which invalid characters will be removed.
 * @returns A new string with all invalid file name characters removed.
 * 
 * @since 4.0.0
 * @version 2021-12-09
 */
export function RemoveInvalidCharactersFromFileName(filename: string) {
    return RemoveAllSubStrings(filename, ...GetInvalidFileNameChars());
}
